export const adRoutes = [
  {
    path: '/ad/sp-ad',
    redirect: '/ad/sp-ad/ad-manager',
    component: () => import('@/views/modules/ad/sp/sp-ad'),
    meta: { name: '商品广告', keepAlive: true, permission: 'adsSpCampaigns:view', modal:'广告'},
    children: [
      {
        path: 'ad-manager',
        component: import('@/views/modules/ad/sp/ad-manager/ad-manager'),
        props: (route) => ({
          marketId: route.query.marketId,
          portfolioId: route.query.portfolioId,
          activeTab: route.query.activeTab
        }),
        meta: {modal: '广告'}
      },
      {
        path: 'ad-campaign-manager/:campaignId',
        component: import('@/views/modules/ad/sp/ad-campaign-manager/ad-campaign-manager'),
        props: (route) => ({
          marketId: route.query.marketId,
          campaignId: route.params.campaignId,
          activeTab: route.query.activeTab,
        }),
        meta: { modal: '广告' }
      },
      {
        path: 'ad-group-manager/:campaignId/:groupId',
        component: import('@/views/modules/ad/sp/ad-group-manager/ad-group-manager'),
        props: (route) => ({
          marketId: route.query.marketId,
          campaignId: route.params.campaignId,
          groupId: route.params.groupId,
          activeTab: route.query.activeTab
        }),
        meta: { modal: '广告' }
      }
    ]
  },
  {
    path: '/ad/sd-ad',
    redirect: '/ad/sd-ad/ad-manager',
    component: () => import('@/views/modules/ad/sd/sd-ad'),
    meta: { name: '展示广告', keepAlive: true, permission: 'adsSdCampaigns:view', modal:'广告'},
    children: [
      {
        path: 'ad-manager',
        component: import('@/views/modules/ad/sd/ad-manager/ad-manager'),
        props: (route) => ({
          marketId: route.query.marketId,
          portfolioId: route.query.portfolioId,
          activeTab: route.query.activeTab
        }),
        meta: { modal: '广告' }
      },
      {
        path: 'ad-campaign-manager/:campaignId',
        component: import('@/views/modules/ad/sd/ad-campaign-manager/ad-campaign-manager'),
        props: (route) => ({
          marketId: route.query.marketId,
          campaignId: route.params.campaignId,
          activeTab: route.query.activeTab,
        }),
        meta: { modal: '广告' }
      },
      {
        path: 'ad-group-manager/:campaignId/:groupId',
        component: import('@/views/modules/ad/sd/ad-group-manager/ad-group-manager'),
        props: (route) => ({
          marketId: route.query.marketId,
          campaignId: route.params.campaignId,
          groupId: route.params.groupId,
          activeTab: route.query.activeTab
        }),
        meta: { modal: '广告' }
      }
    ]
  },
  {
    path: '/ad/sb-ad',
    redirect: '/ad/sb-ad/ad-manager',
    component: () => import('@/views/modules/ad/sb/sb-ad'),
    meta: { name: '品牌广告', keepAlive: true, permission: 'adsSbCampaigns:view', modal: '广告' },
    children: [
      {
        path: 'ad-manager',
        component: import('@/views/modules/ad/sb/ad-manager/ad-manager'),
        props: (route) => ({
          marketId: route.query.marketId,
          portfolioId: route.query.portfolioId,
          activeTab: route.query.activeTab
        }),
        meta: { modal: '广告' }
      },
      {
        path: 'ad-campaign-manager/:campaignId',
        component: import('@/views/modules/ad/sb/ad-campaign-manager/ad-campaign-manager'),
        props: (route) => ({
          marketId: route.query.marketId,
          campaignId: route.params.campaignId,
          activeTab: route.query.activeTab,
        }),
        meta: { modal: '广告' }
      }
    ]
  },
  {
    path: "/ad/sb-ad-add",
    name: "sb-ad-add",
    component: () => import('@/views/modules/ad/sb/ad-add/ad-add'),
    meta: { name: '新增广告活动', keepAlive: true, permission: 'adsSbCampaigns:update' ,modal:'广告'},
  },
  {
    path: "/ad/sb-ad-edit",
    name: "sb-ad-edit",
    component: () => import('@/views/modules/ad/sb/ad-add/ad-edit'),
    meta: { name: '编辑广告活动', keepAlive: true, permission: 'adsSbCampaigns:update' ,modal:'广告'},
  },
  {
    path: "/ad/sb-ad-details",
    name: "sb-ad-details",
    component: () => import('@/views/modules/ad/sb/ad-details/ad-details'),
    meta: { name: '查看广告活动', keepAlive: true, permission: 'adsSbCampaigns:detail' ,modal:'广告'},
  },
  {
    path: '/ad/asin-analysis',
    component: () => import('@/views/modules/ad/analysis/asin/ad-asin-analysis'),
    props: (route) => ({
      startDate: route.query.startDate,
      endDate: route.query.endDate,
    }),
    meta: { name: 'ASIN分析', keepAlive: true, permission: 'adsAsinPerformance:view',modal:'广告' },
  },
  {
    path: '/ad/keyword-analysis',
    component: () => import('@/views/modules/ad/analysis/keyword/ad-keyword-analysis'),
    meta: { name: '关键词分析', keepAlive: true, permission: 'adsKeywordPerformance:view' ,modal:'广告'},
  },
  {
    path: '/ad/search-word-analysis',
    component: () => import('@/views/modules/ad/analysis/search-word/ad-search-word-analysis'),
    meta: { name: '搜索词分析', keepAlive: true, permission: 'AdsSearchKeywordPerformance:view' ,modal:'广告'},
  },
  {
    path: '/ad/time-adjust-strategy',
    component: () => import('@/views/modules/ad/strategy/time-adjust/time-adjust-strategy'),
    meta: { name: '分时策略', keepAlive: true, permission: 'adsStrategyTemplate:view' ,modal:'广告'},
  },
  {
    path: '/ad/ad-automate',
    component: () => import('@/views/modules/ad/ad-automate/index'), 
    meta: { name: '广告自动化', keepAlive: true ,permission: 'adsStrategyTemplate:view', modal:'广告'},
  },
  {
    path: '/ad/strategy-adjust-log',
    component: () => import('@/views/modules/ad/strategy/log/strategy-adjust-log'),
    meta: { name: '调整日志', keepAlive: true, permission: 'adsStrategyObjectLog:view',modal:'广告' },
  },
  {
    path: '/ad/keyword-rank',
    component: () => import('@/views/modules/ad/rank/keyword-rank/ad-keyword-rank'),
    meta: { name: '关键词排名', keepAlive: true, permission: 'keywordRank:view' ,modal:'广告'},
  },
  {
    path: '/ad/add-rule-template',  
    component: () => import('@/views/modules/ad/ad-automate/add-rule-template'),
    meta: { name: '新增自动模板规则', keepAlive: true, permission: 'adsStrategyTemplate:view' ,modal:'广告'},
  },
  {
    path: '/ad/add-rule-template/edit', 
    component: () => import('@/views/modules/ad/ad-automate/add-rule-template'),
    meta: { name: '编辑自动规则', keepAlive: true, permission: 'adsStrategyTemplate:view', modal:'广告'},
  },

];
